import useApiMutation from 'shared/hooks/use-api-mutation';

const useReorderCategories = () => {
  return useApiMutation({
    url: '/categories/reorder-indexes',
    method: 'PATCH',
    errorTitle: 'Erro ao ordenar categoria',
    successTitle: 'Ordenar categoria',
    successMessage: 'Ordenação atualizada com sucesso',
    redirectUrl: '/menu/categories',
  });
};

export default useReorderCategories;
